/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGas = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M18.1 8.7c-.7-.7-1.4-1-2.1-1.3-.2-.1-.4-.2-.7-.3-1.1-.6-2.1-3-2.4-4.3-.1-.3-.2-.5-.5-.6-.2-.2-.5-.2-.8-.2 0 .1-7.6 2.3-7.6 10 0 .7.1 1.4.2 2.2s.3 1.6.6 2.4.7 1.6 1.2 2.3 1.1 1.4 1.9 1.9 1.7.9 2.6 1.1c1.3.2 2.7.1 3.9-.3 1-.4 2-.9 2.8-1.7s1.5-1.7 2-2.7c.1-.1.1-.3.2-.4 1.1-2.8.6-5.8-1.3-8.1zm-2.8 10.2c-1.1.8-2.5 1.2-3.9 1-.6-.1-1.3-.3-1.8-.5-.4-.2-.8-.5-1.1-.9-.3-.5-.3-1.2 0-2s.9-1.5 1.7-2.3 1.3-1.6 1.3-2.5v-.1c1.7.8 4.1 2.4 5.1 6-.3.5-.8 1-1.3 1.3zm2.6-3.9c-2.4-5.1-7.7-6-7.7-6-.4-.1-.8.2-1 .5-.3.4-.2.9.1 1.2 0 0 .4.4.4.9 0 .4-.2.7-.6 1.1-1.1 1-1.8 2-2.3 3.1 0 0 0 .1-.1.1C6 14.1 6 12.2 6 12c0-4.7 3.5-6.9 5.3-7.7.5 1.4 1.5 3.7 3.2 4.6.2.1.5.2.7.3.6.2 1 .4 1.4.8 1.2 1.4 1.6 3.2 1.3 5z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgGas as Gas };
